import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import React, { useEffect } from 'react';
import { Tabs, Tab } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useSearchParams } from 'react-router-dom';
import { SubscriptionsTab } from './SubscriptionsTab';
import { useStore } from 'src/stores';
import { PpricingsTab } from './PpricingsTab';
import { CouponsTab } from './CouponsTab';
const tabs = [{
  label: 'Subscriptions',
  name: 'subscriptions'
}, {
  label: 'Coupons',
  name: 'coupons'
}, {
  label: 'Pricings',
  name: 'pricings'
}];
export const ProPricingPage = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    params = _useSearchParams2[0],
    setParams = _useSearchParams2[1];
  const isCouponsEnabled = store.account.featureFlagsStore.getIsCouponsEnabled;
  const visibleTabs = tabs.filter(tab => tab.name !== 'coupons' || isCouponsEnabled);

  // The open tab lives in the URL, so /pro-pricing?tab=coupons opens on coupons and loads only what
  // coupons needs -- the subscriptions tab never mounts, and its walk through every page of
  // subscriptions never starts. Reading it back from the URL also means a tab that disappears when
  // the flags arrive falls back on its own, with no state to correct.
  const requestedTab = params.get('tab');
  const selectedTab = visibleTabs.some(tab => tab.name === requestedTab) ? requestedTab : visibleTabs[0].name;
  const handleTabChange = (e, newValue) => {
    if (!newValue) return;
    const next = new URLSearchParams(params);
    next.set('tab', newValue);
    setParams(next, {
      replace: true
    });
  };

  // The shared lookups every tab decorates its rows from. They run together rather than one after
  // another, and nothing waits behind them: each tab renders against an empty list until they land.
  const loadPage = () => Promise.all([store.stripe.getMeterAsync.run(), store.stripe.getPricesAsync.run(), store.stripe.getAllProductsAsync.run(), store.stripe.getPriceDashboardAsync.run()]);
  useEffect(() => {
    loadPage().catch(e => console.log('useEffect Error', e));
    return () => {
      var _store$stripe$resetSu, _store$stripe, _store$stripe$resetCo, _store$stripe2;
      (_store$stripe$resetSu = (_store$stripe = store.stripe).resetSubscriptionsListLoaded) === null || _store$stripe$resetSu === void 0 || _store$stripe$resetSu.call(_store$stripe);
      (_store$stripe$resetCo = (_store$stripe2 = store.stripe).resetCouponsListLoaded) === null || _store$stripe$resetCo === void 0 || _store$stripe$resetCo.call(_store$stripe2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerTabs
  }, /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "tabs",
    onChange: handleTabChange,
    value: selectedTab
  }, visibleTabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
    key: tab.name,
    label: tab.label,
    value: tab.name
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.contentWrapper
  }, selectedTab === 'subscriptions' && /*#__PURE__*/React.createElement(SubscriptionsTab, null), selectedTab === 'coupons' && isCouponsEnabled && /*#__PURE__*/React.createElement(CouponsTab, null), selectedTab === 'pricings' && /*#__PURE__*/React.createElement(PpricingsTab, null)));
});